export default "__VITE_PUBLIC_ASSET__481c69c7__"